package org.gymly.util

import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi

@OptIn(ExperimentalEncodingApi::class)
actual fun openBytes(mimeType: String, bytes: ByteArray) {
    val b64 = Base64.encode(bytes)
    openBrowserBlob(mimeType, b64)
}

@Suppress("UNUSED_PARAMETER")
private fun openBrowserBlob(mimeType: String, base64: String) {
    js(
        """
        (function() {
          var binary = atob(base64);
          var len = binary.length;
          var bytes = new Uint8Array(len);
          for (var i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
          var blob = new Blob([bytes], { type: mimeType || 'application/octet-stream' });
          var url = URL.createObjectURL(blob);
          window.open(url, '_blank');
        })()
        """,
    )
}

@OptIn(ExperimentalEncodingApi::class)
actual fun downloadBytes(fileName: String, mimeType: String, bytes: ByteArray) {
    val safeName = sanitizeDownloadFileName(fileName)
    val b64 = Base64.encode(bytes)
    triggerBrowserDownload(safeName, mimeType, b64)
}

@Suppress("UNUSED_PARAMETER")
private fun triggerBrowserDownload(fileName: String, mimeType: String, base64: String) {
    js(
        """
        (function() {
          var binary = atob(base64);
          var len = binary.length;
          var bytes = new Uint8Array(len);
          for (var i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
          var blob = new Blob([bytes], { type: mimeType || 'application/octet-stream' });
          var url = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = fileName || 'download';
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          setTimeout(function() {
            a.remove();
            URL.revokeObjectURL(url);
          }, 2000);
        })()
        """,
    )
}
